import api from "./api.service";
import { store } from "../store/store";

const API_SUFFIX = process.env.VUE_APP_API_SUFFIX;

export default class extends api {
  static myContracts() {
    let deviceInfo = store.getters.getDeviceInfo;
    return this.apiRequest(
      API_SUFFIX + "/api/contracts/" + deviceInfo.device_id || 0,
      {},
      "GET"
    );
  }
  static myLicense() {
    let deviceInfo = store.getters.getDeviceInfo;
    return this.apiRequest(
      API_SUFFIX + "/api/license/" + deviceInfo.device_id || 0,
      {},
      "GET"
    );
  }
  static claimLicense(contractId, kitColour, deviceSerial) {
    let deviceInfo = store.getters.getDeviceInfo;
    return this.apiRequest(
      API_SUFFIX + "/api/contract/" + contractId + "/claim",
      {
        contract_id: contractId,
        device_id: deviceInfo.device_id,
        colour: kitColour,
        device_serial_number: deviceSerial
      },
      "POST"
    );
  }

  static relinquishLicense(licenseId) {
    let deviceInfo = store.getters.getDeviceInfo;
    return this.apiRequest(
      API_SUFFIX + "/api/contract/relinquish",
      {
        license_id: licenseId,
        device_id: deviceInfo.device_id
      },
      "DELETE"
    );
  }
  
  static updateContractNotes(contractId, notes) {
    return this.apiRequest(
      API_SUFFIX + "/api/contract/" + contractId + "/notes", {
        notes: notes
      },
      "POST"
    );
  }
}
